import React from 'react'

const Map = () => (
    <iframe src="https://maps.googleapis.com/maps/embed?pb=!1m18!1m12!1m3!1d4832.178354120616!2d0.1198019084056573!3d52.73058319248434!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d7f8c1ef7e7ce5%3A0x8c43c7037b77874!2sTydd%20St%20Giles%20Golf%20and%20Country%20Club!5e0!3m2!1sen!2suk!4v1578696051718!5m2!1sen!2suk" width="100%" height="500" frameBorder="0" border="0" style={{ border: 0 }} allowFullScreen title="Map of our location"></iframe>
)

export default Map